import React from "react";
import NewsAndNotifiactionSection from "../../components/Investor/NewsAndNotification.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const NewsAndNotificationPage = () => {
  return (
    <>
      <MetaComponent
        title="Read the Latest News Updates of Aptech Limited"
        desc="Stay informed with Aptech's latest news updates and official news notifications covering key announcements and developments. Check it out now"
        keywords="Aptech news and notifications, Aptech announcements, Aptech investor relations."
      />
    
      <NewsAndNotifiactionSection />
    </>
  );
};

export default NewsAndNotificationPage;
